<template>
  <OrdersTable :rows="customer_orders"
               :sortable="true"
               @update-sort="updateOrderSort"
               @row-click="viewOrderDetails"
  />
</template>

<script>
import OrdersTable from '../components/OrdersTable.vue';
import api from '../api';

export default {
  props: {
    customerId: {
      type: String,
      default() {
        return ""
      }
    },
    orders: {
      type: Array,
      default() {
        return []
      }
    },
  },
  components: { OrdersTable },
  data() {
    return {
      customer_id: this.$route.params.customer_id,
      customer_orders: this.orders,
      orderTableParams:{
        sortBy: 'created_at',
        sortDirection: 'desc',
        filter: 'seeding',
      },
    }
  },
  emits: ["sizingFormSubmitted"],
  mounted() {
  },
  methods: {
    searchForOrders(searchTerm) {
      this.orderTableParams.query = searchTerm
      this.getCustomerOrders(this.orderTableParams)
    },
    updateOrderSort(sortBy, sortDirection, filter){
      this.orderTableParams = { sortBy: sortBy, sortDirection: sortDirection, filter: filter };
      this.getCustomerOrders(this.orderTableParams);
    },
    viewOrderDetails(order) {
      this.$router.push(`/order/${order.order_number}`);
    },
    generateQuery(params) {
      let query = '?'
      if(params.query) {
        query += `&query=${params.query}`
      }
      if(params.sortBy) {
        query += `&sort_by=${params.sortBy}`
      }
      if(params.sortDirection) {
        query += `&sort_direction=${params.sortDirection}`
      }
      if(params.filter) {
        query += `&filter=${params.filter}`
      }
      return query;
    },
    getCustomerOrders(params){
      let q = this.generateQuery(params);
      api.getCustomerOrders(this.customer_id, q)
        .then(orders => {
          if (typeof orders !== 'undefined') {
            this.customer_orders = orders;
          }
          this.requestCustomerCompleted = true;
        })
        .catch((error) => {
          console.log(error)
        });
    },
  }
}
</script>
